(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aur-mother-landing"] && !Shopify.designMode) return;
  try {
    

(function(){
const root=document.querySelector('.am');if(!root)return;
const form=document.getElementById('am-product-form'),copy=JSON.parse(document.getElementById('am-copy').textContent),button=form.querySelector('.am-add'),error=form.querySelector('.am-error');
const gallery=Array.from(root.querySelectorAll('[data-gallery-image]')),thumbs=Array.from(root.querySelectorAll('[data-gallery-target]'));
function showImage(i){gallery.forEach(e=>e.hidden=e.dataset.galleryImage!==String(i));thumbs.forEach(e=>e.setAttribute('aria-pressed',String(e.dataset.galleryTarget===String(i))))}
thumbs.forEach(b=>b.addEventListener('click',()=>showImage(b.dataset.galleryTarget)));
form.querySelectorAll('[name="am_color"]').forEach(e=>e.addEventListener('change',()=>{const id=form.querySelector('[name="id"]');id.value=e.value;id.dispatchEvent(new Event('change',{bubbles:true}));root.querySelectorAll('[data-price]').forEach(p=>p.textContent=e.dataset.variantPrice);const target=gallery.find(i=>i.alt===e.dataset.colorTitle);if(target)showImage(target.dataset.galleryImage)}));
const dialog=document.querySelector('.am-dialog');document.querySelector('[data-card-preview]').addEventListener('click',()=>dialog.showModal());dialog.querySelector('[data-close-dialog]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});
let initialized=false;
function enhance(){
const letter=form.querySelector('[data-element-id="text-1"] input'),flowers=form.querySelector('[data-element-id="image-swatches-2"]'),stones=form.querySelector('[data-element-id="image-swatches-3"]'),card=form.querySelector('[data-element-id="image-swatches-4"]'),toggle=form.querySelector('[data-element-id="checkbox-1"] input');
if(!letter||!flowers||!stones||!card||!toggle||!form.querySelector('.gpo-clone-atc-button'))return false;
if(initialized)return true;initialized=true;
const labels={'text-1':'letter','image-swatches-2':'flower','image-swatches-3':'stone','image-swatches-1':'font','checkbox-1':'card_toggle','image-swatches-4':'card_choose'};
Object.entries(labels).forEach(([id,key])=>{const l=form.querySelector('[data-element-id="'+id+'"] .label-content');if(l)l.textContent=copy[key]});
letter.maxLength=1;letter.setAttribute('autocomplete','off');letter.addEventListener('input',()=>letter.setCustomValidity(''));
[[letter.closest('[data-element-id]'),copy.letter_hint],[stones,copy.stone_hint]].forEach(([el,text])=>{const p=document.createElement('p');p.className='am-hint';p.textContent=text;el.appendChild(p)});
card.classList.add('am-card-collapsed');const cardButton=document.createElement('button');cardButton.type='button';cardButton.className='am-card-expand';cardButton.textContent=copy.other_cards+' +';cardButton.setAttribute('aria-expanded','false');cardButton.addEventListener('click',()=>{const open=card.classList.toggle('am-card-collapsed')===false;cardButton.setAttribute('aria-expanded',String(open));cardButton.textContent=copy.other_cards+(open?' −':' +')});card.insertBefore(cardButton,card.querySelector('.gpo-ov-wrapper'));
card.querySelectorAll('.gpo-ov-item').forEach(el=>{const radio=el.querySelector('input');if(radio){const name=document.createElement('span');name.className='am-card-name';name.textContent=radio.value;el.appendChild(name)}});
setTimeout(()=>{const font=form.querySelector('[data-element-id="image-swatches-1"] input');if(font&&!form.querySelector('[data-element-id="image-swatches-1"] input:checked'))font.click();if(!toggle.checked)toggle.click();setTimeout(()=>{const mom=card.querySelector('input[value="За майка"]');if(mom&&!mom.disabled&&!card.querySelector('input:checked'))mom.click()},200)},500);
form.querySelector('.am-loading').hidden=true;button.disabled=false;
return true;
}
const observer=new MutationObserver(()=>{if(enhance())observer.disconnect()});observer.observe(form,{childList:true,subtree:true});enhance();
const translateErrors=new MutationObserver(()=>form.querySelectorAll('.help-block.error').forEach(p=>{if(p.textContent.trim()==='This field is required')p.textContent=copy.choose_required}));translateErrors.observe(form,{childList:true,subtree:true,characterData:true});
setTimeout(()=>{if(!initialized){const p=form.querySelector('.am-loading');p.textContent='';const a=document.createElement('a');a.href=location.pathname;a.textContent=copy.fallback;p.appendChild(a)}},20000);
function validatePersonalization(e){error.hidden=true;const letter=form.querySelector('[data-element-id="text-1"] input');let msg='';if(!initialized||!letter||!letter.value.trim()||!form.querySelector('[data-element-id="image-swatches-2"] input:checked')||!form.querySelector('[data-element-id="image-swatches-3"] input:checked'))msg=copy.choose_required;else if(!/^\p{L}$/u.test(letter.value.trim()))msg=copy.letter_error;else if(form.querySelector('[data-element-id="checkbox-1"] input:checked')&&!form.querySelector('[data-element-id="image-swatches-4"] input:checked'))msg=copy.card_required;if(msg){e.preventDefault();e.stopImmediatePropagation();error.textContent=msg;error.hidden=false;error.scrollIntoView({behavior:'smooth',block:'center'})}}
form.addEventListener('submit',validatePersonalization,true);form.addEventListener('click',e=>{if(e.target.closest('button[name="add"]'))validatePersonalization(e)},true);
const sticky=document.querySelector('.am-sticky'),hero=document.querySelector('.am-hero');function stickyState(){const h=hero.getBoundingClientRect(),b=(form.querySelector('.gpo-clone-atc-button')||button).getBoundingClientRect();const threshold=innerWidth<761?-120:0;sticky.hidden=(innerWidth<761?window.scrollY<120:h.bottom>threshold)||(b.top<innerHeight&&b.bottom>0)}addEventListener('scroll',stickyState,{passive:true});addEventListener('resize',stickyState);stickyState();
document.querySelectorAll('a[href="#personalize"]').forEach(a=>a.addEventListener('click',()=>{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'aurore_mother_landing_cta',cta_text:a.textContent.trim()})}));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aur-teacher-hero"] && !Shopify.designMode) return;
  try {
    
(function(){function applyTeacherCopy(){var source=document.querySelector('.aur-t-copy-map');if(!source)return;var pairs=[];try{pairs=JSON.parse(source.textContent)}catch(e){return}var walker=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT);var nodes=[];while(walker.nextNode())nodes.push(walker.currentNode);nodes.forEach(function(node){var parent=node.parentElement;if(!parent||parent.tagName==='SCRIPT'||parent.tagName==='STYLE')return;var value=node.nodeValue;pairs.forEach(function(pair){if(value.indexOf(pair.from)!==-1)value=value.split(pair.from).join(pair.to)});value=value.replace(/(\d)\s*[\u2013\u2014]\s*(\d)/g,'$1 до $2').replace(/\s*[\u2013\u2014]\s*/g,', ');node.nodeValue=value});document.querySelectorAll('[alt],[title],[aria-label]').forEach(function(el){['alt','title','aria-label'].forEach(function(attr){if(!el.hasAttribute(attr))return;var value=el.getAttribute(attr);pairs.forEach(function(pair){if(value.indexOf(pair.from)!==-1)value=value.split(pair.from).join(pair.to)});el.setAttribute(attr,value.replace(/\s*[\u2013\u2014]\s*/g,', '))})})}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',applyTeacherCopy)}else{applyTeacherCopy()}setTimeout(applyTeacherCopy,700)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
